import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ImportButton } from "../../composant/UploadFiles";
export default function Page404() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        bgcolor: "background.default",
        px: 2,
      }}
    >
      {/* Code 404 */}
      <Typography
        sx={{
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 600,
          fontStyle: "normal",
          fontSize: { xs: "6rem", md: "10rem" },
          lineHeight: "1",
          letterSpacing: "0px",
          color: "#BCBCC2",
        }}
      >
        404
      </Typography>

      {/* Title */}
      <Typography
        sx={{
          fontFamily: "'F37 Ginger', sans-serif",
          fontWeight: 700,
          lineHeight: "110%",
          letterSpacing: "-0.75%",
          fontSize: { xs: "24px", md: "36px", lg: "48px", xl: "60px" },
          mb: 2,
        }}
      >
        Oups! Page non trouvée
      </Typography>

      {/* Description */}
      <Typography
        sx={{
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 400,
          fontSize: "14px",
          color: "#BCBCC2",
          mb: 4,
        }}
      >
        La page que vous cherchez n'existe pas ou a été déplacée.
      </Typography>

      {/* Button */}
      <ImportButton onClick={() => navigate("/")}>
        Retour à l'accueil
      </ImportButton>
    </Box>
  );
}
